import React, { useState } from 'react'
import { ModalComponent, CtaArrow } from 'newComponents'
import MarketoForm from '../../../components/MarketoForm'
import './styles.scss'

import horizontalLogo from '../../../images/logos/LaunchDarkly_Horizontal_Primary_Logo_on_Light_RGB.svg'

const ButtonWithModal = (props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const { buttonText, modalTitle, modalSubtitle, formId, appElement, addArrow, toggleCheckbox } = props

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  return (
    <>
      <button
        id="get-button-clicked"
        className="button is-large is-primary border-radius-2 center-text"
        onClick={toggleModal}
      >
        {buttonText} {addArrow && <CtaArrow />}
      </button>
      <ModalComponent modalOpen={modalOpen} toggleModal={toggleModal} appElement={appElement}>
        <div className="section bg-white card">
          <div className="container">
            <div className="is-flex">
              <img
                className="modal-image"
                src={horizontalLogo}
                alt="launchdarkly logo of rocketship and text"
                loading="lazy"
              />
            </div>
            <h3 className="main-modal-title">{modalTitle}</h3>
            {modalSubtitle && (
              <p className="main-modal-subtitle">{modalSubtitle}</p>
            )}
            <br />
            <MarketoForm formId={formId} toggleCheckbox={toggleCheckbox} />
            <br />
            <p className="help">
              By submitting you agree to LaunchDarkly's{' '}
              <a
                href="/policies/terms-of-service/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms
              </a>{' '}
              and{' '}
              <a
                href="/policies/privacy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policies
              </a>
              .
            </p>
          </div>
        </div>
      </ModalComponent>
    </>
  )
}

export default ButtonWithModal
